export function getCurrentTimestamp() {
    return Date.now()
}
